import Axios from "axios";
import useTicketsReportStore from "../../../store/superadmin/ticketsReport";

export const setMissingTransactions = async (clubId) => {
  const store = useTicketsReportStore.getState();
  try {
    store.setMissingTxnsLoading(true);

    const { data } = await Axios.post(
      `${import.meta.env.VITE_GCP_BASE_URL}/findMissingPurchases`,
      { clubId },
      { headers: { "Content-Type": "application/json" } }
    );

    const missingTransactions =
      data?.data?.flatMap((item) =>
        item.tickets?.flatMap(
          (ticket) =>
            ticket?.missingTransactions?.map((txn) => ({
              ...txn,
              groupName: item.groupName,
            })) || []
        )
      ) || [];

    store.setMissingTxns(clubId, missingTransactions);
  } catch {
    // keep existing data on error
  } finally {
    store.setMissingTxnsLoading(false);
  }
};
